import { defineComponent as _defineComponent } from 'vue'

const __default__ = {
  name: 'templateFormComp'
}

import IForm from '../components/form/index.vue'
import { getScrollHeight, isIOS, isLongIOS, isAndroid } from '@/canvas/utils'
import { getQuery } from '@/utils'
import { useCurrentInstance } from '@/lib/useCurrentInstance'
import _ from 'lodash'
import { ref, provide, withDefaults, reactive, computed, onMounted, onBeforeUnmount, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    isTemplatePre: { type: Boolean, default: false },
    component: null,
    context: { default: '' },
    isFloat: { type: Boolean, default: false },
    container: { default: null },
    action: { default: null },
    formInfo: { default: null },
    show: { type: Boolean, default: false }
  },
  emits: ['mounted', 'close-float', 'submit-text', 'form-loaded'],
  setup(__props: any, { emit: emits }) {

const props = __props as { isTemplatePre: boolean, component: {
      name: string
      compId: string
      data: {
        form: {
          successMessage: string
          id: string | number
          [key: string]: any
        }
        transactionTemplate: {
          title: string
          imgUrl: string
          imgUrlPre: string
          height: number
          width: number
          top: number
          left: number
          [key: string]: any
        }
        style: {
          inputStyle: number
          background: string
          [key: string]: any
        } | null
        [key: string]: any
      } | null
    }, context: string, isFloat: boolean, container: HTMLDivElement | null, action: object | null, formInfo: object | null, show: boolean };

const screenOffset = 80
const instance = useCurrentInstance()
let isFullscreen = false
// let isFormFocus = false





const isLongIOSBool = ref<boolean>(isLongIOS as boolean)
const headerOpacity = reactive<{
  opacity: number
}>({
  opacity: 0
})
const headerShow = ref<boolean>(false)
const isHalf = ref<boolean>(false)
const buttonText = ref<string>('')
const formTitle = ref<string>('')
const originalHeight = ref<number>(0)
const screenHeight = ref<number>(0)
const maxOriginalHeight = ref<number>(0)
const hideShow = ref<boolean>(true)

const data = computed(() => {
  return props.component?.data
})

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const title = computed(() => {
  const { transactionTemplate } = data.value || {}
  const { title = '' } = transactionTemplate || {}
  return title
})

const imgUrl = computed(() => {
  const { transactionTemplate } = data.value || {}
  const { imgUrl = '' } = transactionTemplate || {}
  return imgUrl
})

const imgUrlPre = computed(() => {
  const { transactionTemplate } = data.value || {}
  const { imgUrlPre = '' } = transactionTemplate || {}
  return imgUrlPre
})

const imgStyle = computed(() => {
  const { transactionTemplate } = data.value || {}
  const { width = 0, height = 0, top = 0, left = 0 } = transactionTemplate || {}
  return {
    width: `${width}px`,
    height: `${height}px`,
    top: `-${top}px`,
    left: `-${left}px`,
    position: 'absolute'
  }
})

const contentRef = ref<{ confirm: () => void } | null>(null)
const formStyle = computed(() => {
  const { background = '', ...style } = data.value?.style || {}
  const isBackgroundImage = /^http(s)?:\/\//.test(background)
  return {
    ...style,
    backgroundImage: isBackgroundImage ? `url(${background})` : '',
    backgroundColor: isBackgroundImage ? '' : background
  }
})

const className = computed(() => {
  const { inputStyle = 1 } = formStyle.value || {}
  return `form-input-style-${inputStyle}`
})

const buttonStyle = computed(() => {
  return {
    bottom: 0,
    height: isLongIOSBool.value ? '94px' : '60px'
  }
})
const isHasFormId = computed(() => {
  return props?.component?.data?.form?.id || ''
})

function getStyle() {
  const play = getQuery('gaoneng_play_style') || ''
  const half = getQuery('gaoneng_half_style') || ''
  // 0 外跳 1 拉起面板
  if (+play === 1) {
    headerShow.value = true
  }
  // 0 不支持上滑 1 支持上滑
  if (+half === 0) {
    isHalf.value = true
  }
}


function handleScroll() {
  const scrollTop = getScrollHeight() || 0
  if (headerOpacity.opacity > 190) {
    return
  }
  let headerOpacityCur = Number((scrollTop / 190).toFixed(2))
  headerOpacityCur = headerOpacityCur > 1 ? 1 : headerOpacityCur
  headerOpacity.opacity = Number(headerOpacityCur)
}
function setSubmitValue(value: string, title: string) {
  buttonText.value = value
  formTitle.value = title
  emits('submit-text', value, title)
}
function onSubmit() {
  instance.$toast(props.component?.data?.form?.successMessage || '提交成功')
  if (props.isFloat) {
    emits('close-float')
  }
}
function confirm() {
  contentRef.value?.confirm && contentRef?.value?.confirm()
}

// 面板场景处理
function watchPanelResize() {
  screenHeight.value = document.documentElement.clientHeight
  if (screenHeight.value > maxOriginalHeight.value) {
    maxOriginalHeight.value = screenHeight.value
  }
  if (screenHeight.value < originalHeight.value - screenOffset) {
    handleFocus()
  } else {
    handleBlur()
  }

}
// 外跳页面场景处理
function watchPageResize() {
  screenHeight.value = document.documentElement.clientHeight
  if (screenHeight.value > maxOriginalHeight.value) {
    maxOriginalHeight.value = screenHeight.value
  }
  if (screenHeight.value < originalHeight.value - screenOffset) {
    handleFocus()
  } else {
    handleBlur()
  }
}


function handleFocus () {
  hideShow.value = false
}

function handleBlur () {
  hideShow.value = true

}
function touchInit () {
  document.addEventListener('touchmove', ()=> {
      if (document.activeElement) {
        setTimeout(()=> {
          document.activeElement?.blur && document.activeElement?.blur()
          if (isIOS && !hideShow.value) {
            handleBlur()
          }
          if (headerShow.value) {
            if (isAndroid) {
                handleBlur()
            }
          } else {
            if (isAndroid && (screenHeight.value > originalHeight.value - screenOffset) && !hideShow.value) {
              handleBlur()
            }
          }
        })
      }
  })
  // document.addEventListener('touchmove', ()=> {
  //   if (document.activeElement) {
  //     document.activeElement?.blur && document.activeElement?.blur()
  //     setTimeout(()=> {
  //       if (isAndroid) {
  //         handleBlur()
  //       }
  //       // handleBlur()
  //     })
  //   }
  // })
}
const throttleHandleScroll = _.throttle(handleScroll, 200)
const throttleTouchInit = _.throttle(touchInit, 200)



function registerKeywords() {
  if (!(isAndroid || isIOS)) {
    return
  }
  if (isIOS) {
    document.addEventListener('focusin', (e)=> {
      if (e.target && e.target?.tagName === 'INPUT') {
        // const targetPosition = e.target.getBoundingClientRect().top + window.scrollY
        // window.scrollTo({
        //   top: targetPosition,
        //   behavior: 'smooth'
        // });
        handleFocus()
      }
    })
    document.addEventListener('focusout', handleBlur)
  }
  if (isAndroid) {
    if (headerShow.value) {
      window.addEventListener('resize', watchPanelResize)
    } else {
      window.addEventListener('resize', watchPageResize)
    }
  }
  throttleTouchInit()
}

function unRegisterKeywords() {
  if (!(isAndroid || isIOS)) {
    return
  }
  if (isIOS) {
    document.removeEventListener('focusin', handleFocus)
    document.removeEventListener('focusout', handleBlur)
  }
  if (isAndroid) {
    if (headerShow.value) {
      window.removeEventListener('resize', watchPanelResize)
    } else {
      window.removeEventListener('resize', watchPageResize)
    }
  }
}
function formLoadedHandle () {
  emits('form-loaded')
}

watch(screenHeight, (newValue) => {
  hideShow.value = originalHeight.value <=  newValue + screenOffset
})

onMounted(()=> {
  emits('mounted')
  //获取首次进入页面的原始高度
  originalHeight.value = document.documentElement.clientHeight
  maxOriginalHeight.value = originalHeight.value
  getStyle()
  window.addEventListener('scroll', throttleHandleScroll)
  // window.addEventListener('resize', watchResize)
  registerKeywords()
  setTimeout(()=> {
    formLoadedHandle()
  }, 1000)
})

onBeforeUnmount(() => {
  window.removeEventListener('scroll', throttleHandleScroll)
  unRegisterKeywords()
  // window.removeEventListener('resize', watchResize)
})

provide('compName', props.component.name)
provide('compId', props.component.compId)

return { __sfc: true,screenOffset, instance, isFullscreen, props, emits, isLongIOSBool, headerOpacity, headerShow, isHalf, buttonText, formTitle, originalHeight, screenHeight, maxOriginalHeight, hideShow, data, title, imgUrl, imgUrlPre, imgStyle, contentRef, formStyle, className, buttonStyle, isHasFormId, getStyle, handleScroll, setSubmitValue, onSubmit, confirm, watchPanelResize, watchPageResize, handleFocus, handleBlur, touchInit, throttleHandleScroll, throttleTouchInit, registerKeywords, unRegisterKeywords, formLoadedHandle, IForm }
}

})